import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { freestarQueue } from "./freestar-queue";

interface FreestarAdSlotProps {
  placementName: string;
  slotId: string;
  adSize: string;
  className?: string;
}

function FreestarSlotElement({ placementName, slotId, adSize, className }: FreestarAdSlotProps) {
  useEffect(() => {
    freestarQueue((freestar) => freestar.newAdSlots([{ placementName, slotId }]));
    return () => {
      freestarQueue((freestar) => freestar.deleteAdSlots(slotId));
    };
  }, [placementName, slotId]);

  return <div className={className} data-freestar-ad={adSize} id={slotId} />;
}

// Remounting on navigation and filter changes deletes the slot and requests a fresh ad. The key settles one tick late
// so a page that rewrites its URL in a mount effect does not mount, delete, and re-request the same slot back to back.
const FreestarAdSlot = (props: FreestarAdSlotProps) => {
  const { pathname, search } = useLocation();
  const url = `${pathname}${search}`;
  const [settledUrl, setSettledUrl] = useState<string | null>(null);

  useEffect(() => {
    const timer = setTimeout(() => setSettledUrl(url));
    return () => clearTimeout(timer);
  }, [url]);

  if (!settledUrl) return null;

  return <FreestarSlotElement key={settledUrl} {...props} />;
};

export default FreestarAdSlot;
